import {divide} from 'metaserver/static/js/encrypted_folder/utils/bigint';

export function areUint8ArraysEqual(array1: Uint8Array, array2: Uint8Array): Boolean {
  if (array1.length !== array2.length) {
    return false;
  }

  return array1.every((value, index) => value === array2[index]);
}

export function hexStringToBytes(hexString: string): Uint8Array<ArrayBuffer> {
  const length = hexString.length / 2;
  const uint8Array = new Uint8Array(length);

  for (let i = 0; i < length; i++) {
    const byte = parseInt(hexString.substr(i * 2, 2), 16);
    uint8Array[i] = byte;
  }

  return uint8Array;
}

export function bytesToHexString(bytes: Uint8Array): string {
  return bytes.reduce((str, byte) => str + byte.toString(16).padStart(2, '0'), '');
}

export function encodeBase58(bytes: Uint8Array): string {
  const BASE58_ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';

  let zeroCounter = 0;
  while (bytes[0] === 0) {
    zeroCounter++;
    bytes = bytes.slice(1);
  }

  const result = [];
  while (bytes.length > 0) {
    if (bytes.every((byte) => byte === 0)) {
      break;
    }
    const divided = divide(bytes, 58);
    result.push(BASE58_ALPHABET[divided.remainder]);
    bytes = divided.quotient;
  }

  return '1'.repeat(zeroCounter) + result.reverse().join('');
}
